module.exports = __webpack_public_path__ + "static/fb_ads-f54a3f3f4069ad62b542b64226c2955d.svg";